<template>
  <v-flex md12 xs12>
    <v-card
      outlined
      color="background"
      style="border-color: #79797942 !important"
    >
      <v-alert
        border="left"
        prominent
        dense
        text
        type="error"
        class="ma-0"
        style="border-bottom-right-radius: 0; border-bottom-left-radius: 0"
        v-if="product.valid == false"
      >
        <v-row align="center">
          <v-col class="grow"> Error: {{ product.message }} </v-col>
          <v-col
            class="shrink"
            v-if="product.out_of_stock == 1 && stock_alert_enabled"
          >
            <v-btn
              color="error"
              outlined
              @click="stockAlert()"
              :loading="$store.getters['stockAlerts/retrieveLoading']"
            >
              Request Stock Alert
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>

      <v-layout row wrap justify-start align-center style="margin: 1px">
        <v-flex md2 xs4>
          <v-layout row wrap justify-start align-center>
            <v-flex md12 py-0>
              <ProductImage :product="product"></ProductImage>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex md10 xs8>
          <v-card flat color="background">
            <v-layout row wrap justify-center align-center>
              <v-flex fill-height md12 xs12>
                <v-layout row wrap justify-space-between align-start>
                  <v-flex fill-height md4 xs12>
                    <ProductName :product="product"></ProductName>
                  </v-flex>

                  <v-flex
                    class="hidden-sm-and-down"
                    fill-height
                    md3
                    xs12
                    v-if="!isReadOnly"
                  >
                    <v-btn
                      color="error"
                      text
                      @click="$emit('deleteTrollyItem', product)"
                      >Delete</v-btn
                    >
                  </v-flex>

                  <v-flex fill-height md5 xs12>
                    <GridInput
                      :product="product"
                      :isBasketItem="true"
                      :isStandingOrder="isStandingOrder"
                      :isReadOnly="isReadOnly"
                    ></GridInput>
                  </v-flex>

                  <v-flex class="hidden-md-and-up" fill-height md3 xs12>
                    <v-btn
                      color="error"
                      text
                      @click="$emit('deleteTrollyItem', product)"
                      >Delete</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions } from "vuex";

import ProductImage from "@/components/product/ProductImage.vue";
import ProductName from "@/components/product/ProductName.vue";

import GridInput from "@/components/product/GridInput.vue";

export default {
  components: {
    ProductImage,
    ProductName,
    GridInput,
  },

  props: {
    product: {},
    isStandingOrder: Boolean,
    isReadOnly: Boolean,
  },

  data() {
    return {
      stock_alert_enabled: false,
    };
  },
  computed: {
    itemPrice() {
      switch (this.product.qty_type) {
        case "E":
          if (
            !this.$store.getters.retrieveIsCncCustomer &&
            !this.$store.getters.retrieveIsCashCustomer &&
            parseInt(this.product.catch_weight_flag) == 2
          ) {
            return parseFloat(this.product.kilo_price).toFixed(2) + "/kg";
          } else {
            return parseFloat(this.product.itemPrice).toFixed(2);
          }

        default:
          return parseFloat(this.product.itemPrice).toFixed(2);
      }
    },

    isProdGrid() {
      if (this.$store.getters.retrieveProductGrid) {
        return true;
      } else {
        return false;
      }
    },
    showCode() {
      return this.$store.getters.retrieveProductCode;
    },
    showCountry() {
      return this.$store.getters.retrieveProductCountry;
    },
    productDisplayQty() {
      return parseFloat(this.product.qty).toFixed(2).replace(/\.0+$/, "");
    },
  },

  methods: {
    ...mapActions(["getTrollys"]),

    async stockAlert() {
      console.log("Stock Alert");

      await this.$store.dispatch(
        "stockAlerts/addStockAlert",
        this.product.prod_no
      );
    },
  },
};
</script>

<style lang="sass" scoped>
</style>